module.exports = __webpack_public_path__ + "img/shangyiye.c04468f3.png";